/* Lisa Kookt (03-11-2026): extra foto's op de productkaart.
   Mobiel: puntjes bijwerken bij vegen. Desktop: als de muis op de foto
   blijft staan, loopt een balkje vol en komt rustig de volgende foto.
   Werkt ook voor kaarten die later worden bijgeladen (scroll, aanbevelingen).
   Hoort bij snippets/lk-cardswipe.liquid en assets/lk-cardswipe.css.

   03-11 (avond, JJ): foto's worden nu VOORGELADEN voordat de overlay zichtbaar
   wordt. Eerder kreeg de overlay-laag een nieuwe src en werd meteen getoond,
   maar een <img> blijft zijn oude beeld tonen tot de nieuwe is geladen. Daardoor
   zag je heel even de foto van twee stappen terug (leek op een verkeerde
   volgorde, o.a. bij de witbrood bakmix). */
(function () {
  'use strict';

  var HOVER_MS = 3600;        // tijd per foto op desktop (03-11 JJ: was 2400, 1,5x trager)
  var desktop = window.matchMedia('(hover: hover) and (min-width: 768px)');

  function withWidth(src, w) {
    if (!src) return src;
    src = src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* ---------- mobiel: puntjes ---------- */
  function initDots(cs) {
    var track = cs.querySelector('.lk-cs__track');
    var dots = cs.querySelectorAll('.lk-cs__dot');
    if (!track || !dots.length) return;
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i < 0) i = 0;
        if (i > dots.length - 1) i = dots.length - 1;
        for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-on', k === i);
      });
    }, { passive: true });
  }

  /* ---------- desktop: hover-cyclus ---------- */
  function initHover(cs) {
    var block = cs.closest('.wbimgblock');
    var bar = cs.querySelector('.lk-cs__bar');
    var ovs = cs.querySelectorAll('.lk-cs__hoverimg');
    if (!block || !bar || ovs.length < 2) return;

    var timer = null;
    var idx = 1;        // het thema toont bij hover al de tweede foto (index 1)
    var active = -1;    // welke overlay-laag nu zichtbaar is
    var session = 0;    // telt hovers, zodat een late load van een vorige hover niets meer doet
    var cache = {};     // src -> true zodra geladen

    function slides() {
      return cs.querySelectorAll('.lk-cs__img');
    }

    function srcOf(i) {
      var s = slides();
      return s[i] ? withWidth(s[i].getAttribute('src'), 600) : null;
    }

    function preload(src, cb) {
      if (!src) return;
      if (cache[src]) { if (cb) cb(); return; }
      var im = new Image();
      im.onload = function () { cache[src] = true; if (cb) cb(); };
      im.onerror = function () { if (cb) cb(); };
      im.src = src;
    }

    function runBar() {
      bar.classList.remove('is-run');
      bar.style.width = '0';
      void bar.offsetWidth;
      bar.style.width = '';
      bar.style.setProperty('--lk-cs-ms', HOVER_MS + 'ms');
      bar.classList.add('is-run');
    }

    function show(i) {
      var src = srcOf(i);
      if (!src) return;
      var mySession = session;
      preload(src, function () {
        if (mySession !== session) return;   // muis is intussen weg of opnieuw binnen
        var next = active === 0 ? 1 : 0;
        var img = ovs[next];
        img.src = src;
        img.classList.add('is-on');
        if (active > -1) {
          var prev = ovs[active];
          window.setTimeout(function () { if (mySession === session) prev.classList.remove('is-on'); }, 450);
        }
        active = next;
      });
    }

    function step() {
      var n = slides().length;
      idx = (idx + 1) % n;
      show(idx);
      runBar();
      preload(srcOf((idx + 1) % n));   // alvast de volgende
      timer = window.setTimeout(step, HOVER_MS);
    }

    function start() {
      if (!desktop.matches) return;
      if (slides().length < 3) return;   // bij 2 foto's is er na de hover-foto niets meer
      stop();
      session++;
      idx = 1;
      cs.classList.add('is-hover');
      runBar();
      preload(srcOf(2));                 // de eerste die wij zelf tonen
      timer = window.setTimeout(step, HOVER_MS);
    }

    function stop() {
      session++;
      if (timer) { window.clearTimeout(timer); timer = null; }
      cs.classList.remove('is-hover');
      bar.classList.remove('is-run');
      bar.style.width = '0';
      for (var k = 0; k < ovs.length; k++) ovs[k].classList.remove('is-on');
      active = -1;
    }

    block.addEventListener('mouseenter', start);
    block.addEventListener('mouseleave', stop);
  }

  function init(root) {
    var list = (root || document).querySelectorAll('.lk-cs:not([data-lk-init])');
    for (var i = 0; i < list.length; i++) {
      list[i].setAttribute('data-lk-init', '1');
      initDots(list[i]);
      initHover(list[i]);
    }
  }

  /* ---------- variantkeuze op de kaart: eerste dia en links bijwerken ---------- */
  function onVariantChange(event) {
    var d = event && event.data;
    if (!d || !d.sectionId || !d.variant) return;
    var nodes = document.querySelectorAll('.lk-cs[data-lk-key="' + d.sectionId + '"]');
    for (var i = 0; i < nodes.length; i++) {
      var cs = nodes[i];
      var links = cs.querySelectorAll('.lk-cs__slide');
      if (links.length) {
        var base = links[0].getAttribute('href').split('?')[0] + '?variant=' + d.variant.id;
        for (var k = 0; k < links.length; k++) links[k].setAttribute('href', base);
      }
      var fi = d.variant.featured_image;
      var first = cs.querySelector('.lk-cs__img--first');
      if (fi && fi.src && first) {
        first.removeAttribute('srcset');
        first.src = withWidth(fi.src, 600);
      }
    }
  }

  function boot() {
    init(document);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
    }
    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var k = 0; k < added.length; k++) {
            if (added[k].nodeType === 1) init(added[k].parentNode || document);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', function () { init(document); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
